module.exports = __webpack_public_path__ + "img/dcom04.363a16c8.png";